import { useEffect, useState } from "react";
import { Search, Home } from "lucide-react";
import { Navbar, Footer } from "@/components/Navbar";
import { RentalCard } from "@/components/Cards";
import api from "@/lib/api";

export default function Rentals() {
  const [meta, setMeta] = useState({ cities: [], regions: [], rental_types: [] });
  const [rentals, setRentals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ city: "", region: "", type: "", max_price: "", q: "" });

  useEffect(() => { api.get("/meta").then((r) => setMeta(r.data)); }, []);

  useEffect(() => {
    setLoading(true);
    const params = {};
    Object.entries(filters).forEach(([k, v]) => { if (v) params[k] = v; });
    api.get("/rentals", { params }).then((r) => setRentals(r.data)).finally(() => setLoading(false));
  }, [filters]);

  return (
    <div className="min-h-screen bg-[#fafaf8]">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex items-center gap-3">
          <span className="w-11 h-11 rounded-xl bg-[#e8f0ec] flex items-center justify-center"><Home className="w-5 h-5 text-[#1b5e3f]" /></span>
          <div>
            <h1 className="font-head text-2xl sm:text-3xl font-semibold text-[#1c1917]">Aluguéis & Imóveis</h1>
            <p className="text-[#78716c] text-sm">Encontre apartamentos, quartos e casas na comunidade.</p>
          </div>
        </div>

        <div data-testid="rentals-public-info" className="mt-6 rounded-2xl border border-[#1b5e3f]/20 bg-[#e8f0ec] p-5">
          <p className="font-head font-semibold text-[#1c1917]">Anuncie o seu imóvel — o 1.º anúncio é grátis 🎉</p>
          <p className="text-sm text-[#1b5e3f] mt-1">A partir do 2.º imóvel, cada anúncio tem o valor de <strong>10€</strong>. Tens acesso a uma área privada onde podes gerir o teu anúncio e os contactos que receberes. Podes resolver questões, trocar informações e organizar visitas de forma eficiente através do nosso chat.</p>
        </div>

        <div className="bg-white rounded-2xl border border-[#e7e5e4] shadow-sm p-5 mt-6 grid sm:grid-cols-2 lg:grid-cols-5 gap-3">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#78716c]" />
            <input data-testid="rental-search" value={filters.q} onChange={(e) => setFilters({ ...filters, q: e.target.value })} placeholder="Buscar" className="w-full bg-white border border-[#e7e5e4] rounded-xl pl-9 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1b5e3f]/20 focus:border-[#1b5e3f]" />
          </div>
          <select data-testid="rental-filter-city" value={filters.city} onChange={(e) => setFilters({ ...filters, city: e.target.value })} className="bg-white border border-[#e7e5e4] rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1b5e3f]/20">
            <option value="">Cidade</option>
            {meta.cities.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
          <select data-testid="rental-filter-type" value={filters.type} onChange={(e) => setFilters({ ...filters, type: e.target.value })} className="bg-white border border-[#e7e5e4] rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1b5e3f]/20">
            <option value="">Tipo</option>
            {meta.rental_types.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
          <select data-testid="rental-filter-region" value={filters.region} onChange={(e) => setFilters({ ...filters, region: e.target.value })} className="bg-white border border-[#e7e5e4] rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1b5e3f]/20">
            <option value="">Região</option>
            {meta.regions.map((rg) => <option key={rg} value={rg}>{rg}</option>)}
          </select>
          <input data-testid="rental-filter-price" type="number" value={filters.max_price} onChange={(e) => setFilters({ ...filters, max_price: e.target.value })} placeholder="Preço máx €" className="bg-white border border-[#e7e5e4] rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1b5e3f]/20" />
        </div>

        <div className="mt-8">
          {loading ? (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{[1,2,3].map((i) => <div key={i} className="h-72 rounded-2xl bg-[#e7e5e4]/40 animate-pulse" />)}</div>
          ) : rentals.length === 0 ? (
            <div className="bg-white rounded-2xl border border-[#e7e5e4] p-12 text-center text-[#78716c]">Nenhum imóvel encontrado.</div>
          ) : (
            <>
              <p className="text-sm text-[#78716c] mb-4">{rentals.length} imóvel(is) disponível(is)</p>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{rentals.map((r) => <RentalCard key={r.id} r={r} />)}</div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
